<template>
  <v-container class="px-0">
    <v-row no-gutters>
      <v-col>
        <v-row no-gutters>
          <v-col class="d-flex mb-1">
            <v-btn
              class="mx-2"
              color="secondary"
              small
              @click="openAddCenterDialog"
              ><v-icon>{{ mdiPlus }}</v-icon
              >{{ $t("label.add") }}</v-btn
            >

            <v-dialog v-model="addCenterDialog" width="500" persistent :fullscreen="fullScreenDialog">
              <v-card class="px-1">
                <v-card-title class="headline font-weight-bold dialog-title">
                  {{ $t("label.save_direct_delivery_address") }}
                </v-card-title>
                <v-divider class="py-1"></v-divider>
                <v-text-field
                  v-model="MemberAddress.ContactPerson"
                  :label="$t('label.contact_person')"
                  outlined
                  dense
                  class="px-2 pb-2"
                  :error-messages="ContactPersonMsg"
                  v-uppercase
                  hide-details
                ></v-text-field>
                <v-text-field
                  v-model="MemberAddress.ContactTel"
                  :label="$t('label.contact_tel')"
                  outlined
                  dense
                  class="px-2 pb-2"
                  :error-messages="ContactTelMsg"
                  v-uppercase
                  hide-details
                ></v-text-field>
                <select-country
                  v-model="Country"
                  :change="afterCountry"
                  item-text="CntyName"
                  item-value="CntyCode"
                  :label="$t('label.country')"
                  hide-no-data
                  :onChange="afterCountry"
                  :error-messages="CountryMsg"
                  ref="selectCountry"
                  class="pb-2"
                ></select-country>
                <v-textarea
                  dense
                  outlined
                  v-model="MemberAddress.Address"
                  :error-messages="AddressMsg"
                  class=" pb-2"
                  :label="$t('label.address')"
                  hide-details
                ></v-textarea>
                <v-text-field
                  v-model="MemberAddress.Tag"
                  :label="$t('label.tag')"
                  outlined
                  dense
                  class="px-2 pb-2"
                  :error-messages="TagMsg"
                  v-uppercase
                  hide-details="auto"
                  :hint="$t('message.tag_placeholder')"
                ></v-text-field>
                <v-checkbox
                  v-model="MemberAddress.Defaultsw"
                  :label="$t('label.default_delivery_address')"
                  class="px-2 my-1"
                ></v-checkbox>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="secondary"
                    small
                    @click="saveCenter"
                    class="mr-2"
                  >
                    <v-icon>{{ mdiPlus }}</v-icon
                    >{{ $t("label.save") }}
                  </v-btn>

                  <v-btn color="secondary" small @click="cancelEditMemberAdd">
                    <v-icon>{{ mdiClose }}</v-icon
                    >{{ $t("label.cancel") }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-btn class="mx-2" color="secondary" small @click="searchCenter"
              ><v-icon>{{ mdiRefresh }}</v-icon
              >{{ $t("label.refresh") }}</v-btn
            >
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-tabs
          background-color="#009964"
          center-active
          dark
          v-model="centerTab"
        >
          <v-tab key="centerTab1"> {{ $t("label.all") }}</v-tab>
          <v-tabs-items v-model="centerTab" touchless>
            <v-tab-item key="centerTab1">
              <v-card flat>
                <v-data-table
                  :headers="centerHeaders"
                  :items="centers"
                  :items-per-page="10"
                  class="elevation-1"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn color="secondary" small class="ma-2"
                  @click="editMemberAdd(item)"
                  >
                    {{ $t("label.update") }}
                    <v-icon right> {{ mdiPencil }} </v-icon>
                  </v-btn>
                  <v-btn color="secondary" small class="ma-2"
                  @click="confirmDelete(item)"
                  >
                    {{ $t("label.delete") }}
                    <v-icon right> {{ mdiDelete }} </v-icon>
                  </v-btn>
                    <!-- <v-icon small class="mr-2" @click="editMemberAdd(item)">
                      {{ mdiPencil }}
                    </v-icon>
                    <v-icon small @click="confirmDelete(item)">
                      {{ mdiDelete }}
                    </v-icon> -->
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>

        <v-dialog v-model="deleteCenterDialog" width="500" persistent>
          <v-card class="px-1">
            <v-card-title class="headline font-weight-bold dialog-title">
              {{ $t("label.delete_direct_delivery_address") }}
            </v-card-title>
            <v-divider class="py-1"></v-divider>
            {{ $t("message.are_you_sure") }}
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                small
                @click="deleteMemberAdd"
                class="mr-2"
              >
                <v-icon>{{ mdiPlus }}</v-icon
                >{{ $t("label.confirm") }}
              </v-btn>

              <v-btn
                color="secondary"
                small
                @click="deleteCenterDialog = false"
              >
                <v-icon>{{ mdiClose }}</v-icon
                >{{ $t("label.cancel") }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar" :timeout="timeout" :color="snackbarColor">
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn icon @click="snackbar = false" v-bind="attrs">
          <v-icon>{{ mdiClose }}</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mdiPlus, mdiClose, mdiRefresh, mdiPencil, mdiDelete } from "@mdi/js";
import i18n from "../lang/lang";
import {
  GetCountry,
  GetMemberAdd,
  SaveMemberAdd,
  DeleteMemberAdd,
} from "@/api/publicServices";

export default {
  metaInfo: {
    title: "直送地址",
    titleTemplate: "%s | 控制台 | 青蛙集運",
  },
  data: () => ({
    title: "label.direct_delivery_address",
    centerTab: null,
    centers: [],
    addCenterDialog: false,
    deleteCenterDialog: false,
    ContactPersonMsg: "",
    ContactTelMsg: "",
    CountryMsg: "",
    AddressMsg: "",
    TagMsg:"",
    MemberAddress: {
      ContactPerson: "",
      ContactTel: "",
      Address: "",
      Defaultsw: false,
      Tag:"",
    },

    Country: {
      CntyCode: "HK",
      CntyName: "HONG KONG",
      CnName: "香港",
      TelPrefix: "852",
    },
    snackbar: false,
    snackbarColor: "secondary",
    timeout: 10000,
    text: "",
    preDeleteCenter: null,

    // svg icons
    mdiPlus,
    mdiClose,
    mdiRefresh,
    mdiPencil,
    mdiDelete,
  }),
  components: {},
  methods: {
    openAddCenterDialog() {
      this.MemberAddress = {
        ContactPerson: "",
        ContactTel: "",
        Address: "",
        Tag:"",
      };

      this.Country = {
        CntyCode: "HK",
        CntyName: "HONG KONG",
        CnName: "香港",
        TelPrefix: "852",
      };
      this.addCenterDialog = true;
    },
    openSaveCenterDialog() {
      this.addCenterDialog = true;
    },
    async saveCenter(e) {
      e.preventDefault();

      this.ContactPersonMsg = "";
      this.ContactTelMsg = "";
      this.AddressMsg = "";
      console.log(this.MemberAddress);
      if (this.Country == null) {
        this.CountryMsg = i18n.t("message.required");
        return;
      }

      if (this.MemberAddress.ContactPerson == "") {
        this.ContactPersonMsg = i18n.t("message.required");
        return;
      }
      if (this.MemberAddress.ContactTel == "") {
        this.ContactTelMsg = i18n.t("message.required");
        return;
      }
      if (this.MemberAddress.Address == "") {
        this.AddressMsg = i18n.t("message.required");
        return;
      }
      if (this.MemberAddress.Tag == "") {
        this.TagMsg = i18n.t("message.required");
        return;
      }
      try {
        this.MemberAddress.Country = this.Country.CntyCode;
        const response = await SaveMemberAdd({ MemberAdd: this.MemberAddress });

        if (response.data.isSuccess) {
          this.text = i18n.t("message.save_direct_delivery_address_success");
          this.snackbarColor = "secondary";
          this.snackbar = true;
          this.addCenterDialog = false;

          this.searchCenter();
        } else {
          this.text = response.data.Msg;
          this.snackbarColor = "red";
          this.snackbar = true;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async searchCenter() {
      this.centers = [];
      try {
        const response = await GetMemberAdd({ SearchVal: "" });
        this.centers = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getCountry(CntyCode) {
      try {
        const response = await GetCountry({ Country: CntyCode });
        this.Country = response.data;

        if (this.$refs.selectCountry) {
          this.$refs.selectCountry.setCountry(this.Country);
        }
      } catch (error) {
        console.log(error);
      }
    },
    cancelEditMemberAdd() {
      this.addCenterDialog = false;
      this.searchCenter();
    },
    async editMemberAdd(center) {
      this.MemberAddress = center;
      this.getCountry(center.Country);
      this.openSaveCenterDialog();
    },
    confirmDelete(center) {
      this.deleteCenterDialog = true;
      this.preDeleteCenter = center;
    },
    async deleteMemberAdd() {
      try {
        const response = await DeleteMemberAdd({ ID: this.preDeleteCenter.ID });
        if (response.data.isSuccess) {
          this.searchCenter();
        } else {
          this.text = response.data.Msg;
          this.snackbarColor = "red";
          this.snackbar = true;
        }
        this.deleteCenterDialog = false;
      } catch (error) {
        console.log(error);
      }
    },
    afterCountry() {},
  },
  computed: {
    fullScreenDialog() {
      return localStorage.getItem("flutter") == "true";
    },

    centerHeaders() {
      return [
        {
          text: i18n.t("label.contact_person"),
          align: "start",
          value: "ContactPerson",
        },
        { text: i18n.t("label.contact_tel"), value: "ContactTel" },
        { text: i18n.t("label.address"), value: "Address" },
        { text: i18n.t("label.country"), value: "Country" },
        { text: i18n.t("label.tag"), value: "Tag" },
        { text: i18n.t("label.actions"), value: "actions", sortable: false },
      ];
    },
  },
  mounted() {
    this.searchCenter();
  },
};
</script>

<style scoped>
@media (max-width: 960px) {
  .v-dialog__content {
    justify-content: center;
    align-items: flex-start;
  }
}
</style>
